import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {desktop, mobile} from '../../const/sizes';
import {LIGHT_GRAY, PRIMARY_RED} from '../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: desktop.contentLargerSpacing,
        },
        title: {
            fontSize: 36,
            fontWeight: 'bold',
            marginBottom: 30,
        },
        formGroup: {
            marginTop: desktop.contentSmallerSpacing,
        },
        passwordLabelContainer: {
            width: '100%',
        },
        passwordStrengthBarContainer: {
            flex: 1,
            marginLeft: 10,
            marginBottom: 10,
        },
        formSubsection: {
            marginTop: mobile.contentLargerSpacing,
        },
        submitContainer: {
            width: '100%',
            marginTop: mobile.contentLargerSpacing,
        },
        submitButton: {
            width: '100%',
        },
        goBackButton: {
            width: '100%',
            marginTop: 10
        },
        termsAndConditionLink: {
            color: PRIMARY_RED,
            marginLeft: '0px !important',
        },
        houseNumber: {},
        [theme.breakpoints.up('md')]: {
            submitButton: {
                width: 300,
            },
            goBackButton: {
                width: 300,
                marginLeft: 10,
                marginTop: 0
            }
        },
    }),
);

export default useStyles;
